// src/lib/opportunity/openOpportunityWorkspace.ts

import {
  setPendingOpportunityOpen,
  type PendingOpportunityTab,
} from "./pendingOpportunityOpen.js";
import { requestWorkspaceMode } from "../workspaceModeNavigation.js";

export function openOpportunityWorkspace(
  opportunityId: string,
  tab: PendingOpportunityTab = "overview",
): void {
  setPendingOpportunityOpen(opportunityId, tab);
  requestWorkspaceMode({ mode: "opportunities" });
}
